module.exports = __webpack_public_path__ + "img/orders-icon.7dc4c453.svg";